'use strict';

exports.newGuid = function () {
  var n;
  var i;
  var guidArray = [];

  for (i = 1; i <= 32; i++) {
    n = Math.floor(Math.random() * 16.0).toString(16);
    guidArray.push(n);

    if ((i == 8) || (i == 12) || (i == 16) || (i == 20))
      guidArray.push('-');
  }

  return guidArray.join('');
};


exports.extendObj = function (destination) {
  var resultObj = {};
  var key;
  var index;
  var source;

  if (destination) {
    for (key in destination) {
      resultObj[key] = destination[key];
    }
  }

  var length = arguments.length;
  if (length >= 2) {
    for (index = 1; index < length; index++) {
      source = arguments[index];
      for (key in source) {
        if(source[key] !== undefined) {
          resultObj[key] = source[key];
        }
      }
    }
  }

  return resultObj;

};

var getVertThumb = function (dom) {
  var scrollView = $(dom).children('.scroll-view').get(0);
  var track = $(scrollView).children('.scroll-bar-vertical').get(0);
  var thumb = $(track).children('.thumb').get(0);
  return thumb;
};

var getHoriThumb = function (dom) {
  var scrollView = $(dom).children('.scroll-view').get(0);
  var track = $(scrollView).children('.scroll-bar-horizontal').get(0);
  var thumb = $(track).children('.thumb').get(0);
  return thumb;
};

exports.setThumbOpaicty = function(dom, opacity) {

  var vertThumb = getVertThumb(dom);
  var horiThumb = getHoriThumb(dom);

  if(vertThumb) {
    $(vertThumb).css('opacity', opacity);
  }
  if(horiThumb) {
    $(horiThumb).css('opacity', opacity);
  }
};

exports.getVertThumb = getVertThumb;
exports.getHoriThumb = getHoriThumb;




// WEBPACK FOOTER //
// ./src/helper/tool.js